<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black confirm-merge-persons-dialog"
    @hide="onDialogHide"
  >
    <div class="confirm-merge-persons-header">
      <h3>{{ $t('Vem skall bort?') }}</h3>
    </div>

    <div class="confirm-merge-persons-row">
      {{ $t('Are you sure you want to save both cards? If not then press cancel and tick the one to be deleted.') }}
    </div>

    <div class="confirm-merge-persons-actions">
      <b-button pill size="sm" variant="secondary" class="text-uppercase btn-text mr-2" @click="onCancelClick">
        <span>{{ $t('confirm-cancel') }}</span>
      </b-button>

      <b-button pill size="sm" variant="primary" class="text-uppercase mx-2" @click="onConfirmClick">
        <span>{{ $t('Confirm') }}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmMergeDialog',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    async onConfirmClick() {
      this.$emit('confirm');
    },

    onCancelClick() {
      this.$emit('cancel');
    },

    onDialogHide() {
      this.$emit('cancel');
    },
  },
};
</script>

<style>
.confirm-merge-persons-dialog .modal-content {
  max-width: 480px;
}

.confirm-merge-persons-dialog .modal-body {
  padding: 32px 52px;
}
</style>

<style scoped>
.confirm-merge-persons-header {
  border-bottom: 2px solid var(--bs-gray-500);
}

.confirm-merge-persons-row {
  min-height: 42px;
  padding: 8px 0;
  border-bottom: 1px solid var(--bs-gray-500);
}

.confirm-merge-persons-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/ConfirmMergeDialog.vue